import { createAction } from 'redux-actions'

export const TOGGLE_SHOW_MORE_ACTIVITY = 'TOGGLE_SHOW_MORE_ACTIVITY'
export const toggleShowMoreActivity = createAction(TOGGLE_SHOW_MORE_ACTIVITY)
export const SET_ACTIVITY_FILTER = 'SET_ACTIVITY_FILTER'
export const setActivityFilter = createAction(SET_ACTIVITY_FILTER)
export const SET_ACTIVITY_SEARCH_TERM = 'SET_ACTIVITY_SEARCH_TERM'
export const setActivitySearchTerm = createAction(SET_ACTIVITY_SEARCH_TERM)
export const SET_ACTIVITY_TYPE = 'SET_ACTIVITY_TYPE'
export const setActivityType = createAction(SET_ACTIVITY_TYPE)
export const SET_PAGINATION_SIZE = 'SET_PAGINATION_SIZE'
export const setPaginationSize = createAction(SET_PAGINATION_SIZE)
export const SET_PAGINATION_PAGE = 'SET_PAGINATION_PAGE'
export const setPaginationPage = createAction(SET_PAGINATION_PAGE)
